export enum Status {
  BeingConfigured = 'BEING CONFIGURED',
  Configured = 'CONFIGURED',
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Undefined = 'null',
  Unpublish = 'UNPUBLISH',
}
